import {Component, HostListener, OnInit, ViewChild} from "@angular/core";
import {Field} from '../../models/field.model';
import {SharedDataService} from '../../../../services/shared/shared-data.service';
import {Ng4LoadingSpinnerService} from "ng4-loading-spinner";
import {DetailService} from "../../../../services/details/detail.service";
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";
import {ToastrService} from "ngx-toastr";
import {HelperService} from "../../../../services/helperService";
import {TranslateService} from "@ngx-translate/core";
import * as ThumborUrlBuilder from "thumbor-url-builder";
import {PostmessageEditor} from "../../../../models/postmessage-editor.model";
import {BsModalRef, BsModalService, ModalOptions} from "ngx-bootstrap/modal";
import {AuthService} from "../../../../services";

@Component({
	selector: "tig-form-editor",
	templateUrl: "form-editor.component.html"
})
export class FormEditorComponent extends Field implements OnInit
{

	/**
	 * Attributes
	 */
	public STR_btn_id: string = 'btn_editor_';
	private OBJ_iframe_ref: BsModalRef;
	public OBJ_iframe_content: SafeHtml;
	// Referenz auf den iFrame im Template
	@ViewChild('OBJ_modal_iframe', {static: false}) OBJ_model_iframe;

	// Listen to messages from iframe
	@HostListener('window:message', ['$event'])
	onMessage(event)
	{
		this.receiveMessageFromIFrame(event);
	}

	/**
	 * @param {SharedDataService} OBJ_subscription_service
	 * @param {Ng4LoadingSpinnerService} OBJ_spinner_service
	 * @param OBJ_detail_service
	 * @param OBJ_sanitizer
	 * @param OBJ_toastr_service
	 * @param OBJ_modal_service
	 * @param OBJ_helper_service
	 * @param OBJ_translate_service
	 * @param OBJ_auth_service
	 */
	constructor(
		private OBJ_subscription_service: SharedDataService,
		private OBJ_spinner_service: Ng4LoadingSpinnerService,
		private OBJ_detail_service: DetailService,
		private OBJ_sanitizer: DomSanitizer,
		private OBJ_toastr_service: ToastrService,
		private OBJ_modal_service: BsModalService,
		private OBJ_helper_service: HelperService,
		private OBJ_translate_service: TranslateService,
		private OBJ_auth_service?: AuthService
	)
	{
		super();
	}

	/**
	 * Function > ngOnInit
	 */
	ngOnInit(): void
	{

		// Uebergangstext bis iFrame geladen ist
		this.OBJ_iframe_content = "<div>Loading...</div>";

		// Erschaffe Observable, um auf Klick zu hoeren
		this.OBJ_subscription_service.createSubject("html_editor");
		this.STR_btn_id += this.OBJ_field_config.name;

	} // end function ngOnInit

	/**
	 * Function > openEditor
	 * @param {HTMLElement} OBJ_btn
	 */
	openEditor(OBJ_btn: HTMLElement)
	{

		let BOO_small = this.OBJ_field_config.small ? this.OBJ_field_config.small : false;
		let STR_editortype = this.OBJ_field_config.editortype ? this.OBJ_field_config.editortype:'default';
		let BOO_htmlcontent = true;
		if(this.OBJ_field_config.htmlcontent !== undefined)
		{
			BOO_htmlcontent = this.OBJ_field_config.htmlcontent;
		}

		// Uebergangsloesung bis alle ihre Konfig angepasst haben
		if(BOO_small)
		{
			STR_editortype = 'small';
			BOO_htmlcontent = false;
		} // end if

		// disable button and show the spinner
		OBJ_btn.setAttribute('disabled', 'disabled');
		this.OBJ_spinner_service.show();
		this.OBJ_detail_service.postToIFrame(this.OBJ_field_config._links.iframe.href, this.OBJ_field_config.name, STR_editortype, BOO_htmlcontent).subscribe(
			OBJ_response => {
				this.OBJ_iframe_content = this.OBJ_sanitizer.bypassSecurityTrustHtml(OBJ_response);
				this.OBJ_helper_service.logWithClassAndFunction("DetailComponent", "openEditor", "loaded iFrame content", this.OBJ_iframe_content);
			},
			OBJ_error => {
				this.OBJ_toastr_service.error("Could not be loaded");
				// hide spinner
				this.OBJ_spinner_service.hide();
			},
			() => {
				let OB_modal_options = new ModalOptions();
				OB_modal_options.ignoreBackdropClick = true;
				OB_modal_options.class = 'tig-modal';

				this.OBJ_iframe_ref = this.OBJ_modal_service.show(this.OBJ_model_iframe, OB_modal_options);
				OBJ_btn.removeAttribute('disabled');

				// hide spinner
				this.OBJ_spinner_service.hide();

			});

	} // end function openEditor

	/**
	 * Function > closeEditorWithoutSaving
	 */
	closeEditorWithoutSaving()
	{
		this.OBJ_iframe_ref.hide();
	}

	/**
	 * Function > changeIframe
	 * @param OBJ_iframe
	 * @param {string} STR_class
	 * @return void
	 */
	changeIframe(OBJ_iframe, STR_class: string): void
	{

		if (OBJ_iframe.className == STR_class)
		{
			OBJ_iframe.className = 'tig-default';
		}
		else
		{
			OBJ_iframe.className = STR_class;
		} // end if

	} // end function changeIframe

	/**
	 * Function > receiveMessageFromIFrame
	 * @param OBJ_event
	 * @return void
	 */
	receiveMessageFromIFrame(OBJ_event): void
	{

		let STR_target = window.location.origin;
		this.OBJ_helper_service.logWithClassAndFunction(
			"DetailComponent", "receiveMessageFromIFrame", [{"Accepted origin": STR_target}]
		);

		// accept only events of certain origin
		if (OBJ_event.data.iframe && OBJ_event.origin == STR_target)
		{

			let OBJ_data: PostmessageEditor = OBJ_event.data;

			// save html content from iframe if this is the right field - important when using several editors in the same form
			if (OBJ_data.event == 'save' && OBJ_data.htmlfield === this.OBJ_field_config.name)
			{

				// fill value field with edited HTML
				this.OBJ_field_config.value = OBJ_data.data;
				// close iframe by field html
				this.OBJ_iframe_ref.hide();

				this.markAsDirtyAndTouched();
			}
			// file upload from iframe
			else if (OBJ_data.event == 'upload')
			{

				// upload image and send message to iframe
				let OBJ_form_data = new FormData();
				OBJ_form_data.append('upload', OBJ_data.data.upload);
				OBJ_form_data.append('json', JSON.stringify(OBJ_data.data.json));
				this.OBJ_detail_service.post('/api/images', OBJ_form_data).subscribe(
					(OBJ_response: any) => {
						// TODO: Config-Daten wie crop und rotate werden aktuell noch ignoriert

						OBJ_response.success = true;
						// Baue URL des Bildes zusammen
						let OBJ_thumbor_url_builder = new ThumborUrlBuilder("infinity", OBJ_response.server);
						OBJ_response.url = "https://" + OBJ_thumbor_url_builder.
							setImagePath(OBJ_response.folderprefix +
								OBJ_response.folder +
								OBJ_response.filename +
								"." + OBJ_response.ext).
							buildUrl();
						OBJ_event.source.postMessage(OBJ_response, OBJ_event.origin);
						this.OBJ_helper_service.log({
							class: "DetailComponent",
							function: "receiveMessageFromIFrame",
							uploadFile: OBJ_response
						});
					},
					(OBJ_error) => {
						OBJ_event.source.postMessage({success: false}, OBJ_event.origin);
						// output saving failed
						this.OBJ_toastr_service.error(this.OBJ_translate_service.instant("oUpload.sFailed"));
					},
					() => {
						// output saving successfully
						this.OBJ_toastr_service.success(this.OBJ_translate_service.instant("oUpload.sSuccessfully"));
					});

			}
			else if (OBJ_data.event == 'generate_hash')
			{
				let OBJ_hash = this.OBJ_helper_service.generateHash(OBJ_data.params, OBJ_data.body, this.OBJ_auth_service.getToken("access_token"));
				// Post data to iFrame
				OBJ_event.source.postMessage(OBJ_hash, OBJ_event.origin);

			} // end if

		} // end if

	} // end function receiveMessageFromIFrame

} // end class FormEditorComponent
